

export default {
  name: 'NavBar',
  components: {
  },
  data () {
    return {
      // 锚点式方向累积（2026-09-13 灵敏度治理）：原实现按单次 scroll 事件的 delta（>6px 即动作）
      // 判断，移动端滚动事件连发、每帧 delta 轻松超 6px——轻扫即隐藏、回弹即闪现。
      // 改为：anchorY 记录上次触发点，|y - anchorY| 累计不足阈值不动作；方向反转时锚点
      // 跟随当前位置重新累计。iOS 回弹自然被吸收（回到锚点附近差值归零）。
      anchorY: 0,
      hidden: false,
      scrollTicking: false
    }
  },
  mounted () {
    // 恢复滚动位置进入页面的场景：锚点取当前值，避免从 0 误判一大段"向下"
    this.anchorY = window.pageYOffset || document.documentElement.scrollTop || 0
    window.addEventListener('scroll', this.onScroll, { passive: true })
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      if (this.scrollTicking) return
      this.scrollTicking = true
      requestAnimationFrame(() => {
        const TRIGGER = 40 // 累计滑动距离阈值：一次有意的滚动轻松超过，轻触/回弹达不到
        const y = window.pageYOffset || document.documentElement.scrollTop
        const delta = y - this.anchorY
        if (Math.abs(delta) < TRIGGER) {
          this.scrollTicking = false
          return
        }
        if (delta > 0 && y > 120) {
          // 自锚点累计向下 ≥40px 且不在页顶 → 隐藏
          this.hidden = true
        } else {
          // 自锚点累计向上 ≥40px → 复原（含页顶区域）
          this.hidden = false
        }
        this.anchorY = y
        this.scrollTicking = false
      })
    }
  }
}
